import { frontendURL } from '../../../helper/URLHelper';
import ProposalsIndex from './pages/ProposalsIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.PROPOSAL_MANAGEMENT,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/proposals'),
    component: ProposalsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'proposals_dashboard_index',
        component: ProposalsIndex,
        meta: commonMeta,
      },
    ],
  },
];
